import httpClient from "./httpClient";

const END_POINT = "/api/tipo_p_d_fs";

const getAll = () =>
  httpClient.get(`${END_POINT}/tipos-listados`, {
    params: { "order[nombre]": "asc", pagination: false },
  });

const getListado = (tipo, options) =>
  httpClient.get(`${END_POINT}/get-listado`, {
    params: { tipo: tipo.id, ...options },
  });

export { getAll, getListado };
